<style scoped>

</style>

<template>
    <div>
        <h1>竞猜开关：{{guessInfo.guessName}}</h1>
        <div class="activity-switch">
            <div class="label">当前开启状态：</div>
            <div class="switch-item">
                <el-switch v-model="guessInfo.guessSwitch" :active-value="1" :inactive-value="2" active-text="运行" inactive-text="停止"></el-switch>
            </div>
        </div>
        <div class="label">定时开启</div>
        <el-date-picker
        size="mini"
        v-model="dateRange"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        format="yyyy-MM-dd HH:mm"
        value-format="yyyy-MM-dd HH:mm">
        </el-date-picker>

        <div class="activity-switch">
            <div class="label">手动模式</div>
            <div class="switch-item">
                <el-switch v-model="guessInfo.actionFlag" :active-value="1" :inactive-value="2" active-text="开启" inactive-text="关闭"></el-switch>
            </div>
        </div>

        <div class="label">猫卡1</div>
        <el-select v-model="guessInfo.catId1" clearable placeholder="请选择" size="mini" style="width:200px;">
            <el-option
            v-for="item in catList"
            :key="item.catId"
            :label="item.catName"
            :value="item.catId">
            </el-option>
        </el-select>

        <div class="label">猫卡2</div>
        <el-select v-model="guessInfo.catId2" clearable placeholder="请选择" size="mini" style="width:200px;">
            <el-option
            v-for="item in catList"
            :key="item.catId"
            :label="item.catName"
            :value="item.catId">
            </el-option>
        </el-select>
        

        <br></br>
        <div>
            <el-button type="primary" @click="saveGuessSwitch">保存配置</el-button>
        </div>
    </div>
</template>

<script>
import { getGuessInfo, getCatList, saveGuessSwitch } from '@/request/api';
export default {
    name: 'GuessSwitch',
    data() {
      return {
        guessId: 0,
        catList: [],
        guessInfo: {},
        dateRange: []
      };
    },
    methods: {
      getCatList() {
        getCatList({}).then(res => {
            var status = res.status;
            var msg = res.msg;
            if (status === '2') {
                this.$message.error(msg);
            } else {
                var data = res.data;
                this.catList = data;
            }
        })
      },
      getGuessInfo() {
        getGuessInfo({
            guessId: this.guessId
        }).then(res => {
            var status = res.status;
            var msg = res.msg;
            if (status === '2') {
                this.$message.error(msg);
            } else {
                this.$message.success("查询成功");
                var data = res.data;
                this.guessInfo = data;
                var startTime = data.startTime;
                var endTime = data.endTime;
                this.dateRange = [startTime, endTime]
            }
        })
      },
      saveGuessSwitch() {
          var params = this.guessInfo 
          params.startTime = this.dateRange[0];
          params.endTime = this.dateRange[1];
          saveGuessSwitch(
              params
          ).then(res => {
                var status = res.status;
                var msg = res.msg;
                if (status === '2') {
                    this.$message.error(msg);
                } else {
                    this.$message.success("保存成功");
                    setTimeout(() => {                        
                         this.getGuessInfo();                  
                     }, 1000);        
                    
                }
            })
      }
    },
    created(){
        var guessId = this.$route.query.guessId
        console.log(guessId);
        this.guessId = guessId;
        this.getCatList();
        this.getGuessInfo();
    }
}
</script>

<style scoped>
.activity-switch {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-top: 10px;
}
.label {
  font-size: 16px;
  width: 200px;
  height: 30px;
  line-height: 30px;
  margin-left: 10px;
}
.switch-item {
    width: 200px;
    height: 30px;
    line-height: 30px;
    margin-left: 10px;
}
</style>




// WEBPACK FOOTER //
// src/page/guess/guessSwitch.vue